import { request } from "../utils/request.js"

export const saleReturnOrder_exportForManage = (pojo, args) => request({
    url: 'saleReturnOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageForManage = (pojo, args) => request({
    url: 'saleReturnOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageListForManage = (pojo, args) => request({
    url: 'saleReturnOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'saleReturnOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'saleReturnOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageForSelect = (pojo, args) => request({
    url: 'saleReturnOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findPageListForSelect = (pojo, args) => request({
    url: 'saleReturnOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_saveIntoDraft = (pojo, args) => request({
    url: 'saleReturnOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'saleReturnOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_update = (pojo, args) => request({
    url: 'saleReturnOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_updateAndSubmit = (pojo, args) => request({
    url: 'saleReturnOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_submitById = (id, args) => request({
    url: 'saleReturnOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_deleteById = (id, args) => request({
    url: 'saleReturnOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_approval = (pojo, args) => request({
    url: 'saleReturnOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleReturnOrder_findById = (id, args) => request({
    url: 'saleReturnOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_findVoById = (id, args) => request({
    url: 'saleReturnOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleReturnOrder_generatePrintPdf = (pojo, args) => request({
    url: 'saleReturnOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/saleReturnOrder.js